<div class="chip-container">
    <category-chip *ngFor="let category of (categories | slice:0:3)" [name]="category.name"></category-chip>
    <category-chip *ngIf="categories.length > 3" name="{{categories.length - 3}}+"></category-chip>
</div>